// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2lKTp","title":"AfterFrontImage_title__3pvzq"};